import { Loader } from "@googlemaps/js-api-loader";

/**
 * This is a wrapper around the Google Maps API client.
 * see https://developers.google.com/maps/documentation/javascript
 */

/** @var {google.maps.PlacesLibrary|undefined} */
let placesApiClient: google.maps.PlacesLibrary | undefined;

export default async function getGoogleMapsPlacesApiClient() {
  if (placesApiClient) {
    return placesApiClient;
  }

  const loader = new Loader({
    apiKey: "AIzaSyAcJo2m5es8ZbUn3T9lsL4H--1rfd7tJRM",
    version: "weekly",
  });

  placesApiClient = await loader.importLibrary("places");

  return placesApiClient;
}
